import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    CreateWorkspaceRequest,
    CreateWorkspaceResponse,
    GetWorkspaceRequest,
    GetWorkspaceResponse,
    UpdateWorkspaceRequest,
    UpdateWorkspaceResponse,
    DeleteWorkspaceRequest,
    DeleteWorkspaceResponse
} from "./types";

export { apiName };

const getWorkspace = getCallable<GetWorkspaceRequest, GetWorkspaceResponse>(
    apiName,
    "getWorkspace",
    {
        ...endpoints.getWorkspace,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}`,
                options: {
                    method: "GET"
                }
            };
        }
    });

const updateWorkspace = getCallable<UpdateWorkspaceRequest, UpdateWorkspaceResponse>(
    apiName,
    "updateWorkspace",
    {
        ...endpoints.updateWorkspace,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}`,
                options: {
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const createWorkspace = getCallable<CreateWorkspaceRequest, CreateWorkspaceResponse>(
    apiName,
    "createWorkspace",
    {
        ...endpoints.createWorkspace,
        composer: request => {
            return {
                url: `/workspaces`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const deleteWorkspace = getCallable<DeleteWorkspaceRequest, DeleteWorkspaceResponse>(
    apiName,
    "deleteWorkspace",
    {
        ...endpoints.deleteWorkspace,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}`,
                options: { method: "DELETE" }
            };
        }
    }
);

export const callables = {
    getWorkspace,
    updateWorkspace,
    createWorkspace,
    deleteWorkspace
};
